/**
 * PricingEngine.js
 * 
 * Pure utility functions for building pricing calculations.
 */

export const calculateRoofPitchAdjustment = (basePrice, pitch) => {
	if (!basePrice || !pitch) return 0;
	
	switch (pitch) {
		case '3/12':
			return 0;
		case '1/12':
			return basePrice * 0.15;
		case '2/12':
		case '4/12':
			return basePrice * 0.1;
		case '5/12':
			return basePrice * 0.15;
		default:
			return 0;
	}
};

export const getCategoryId = (frameGauge, selectedStyle, hasLeanTo) => {
	const gauge = parseInt(frameGauge || 1);
	
	if (selectedStyle === 'wsd') {
		return 18;
	} else if (selectedStyle === 'barn' || selectedStyle === 'slbarn') {
		return gauge === 1 ? 42 : 43;
	} else {
		return gauge === 1 ? 1 : 2;
	}
};

export const calculateSubTotal = (prices) => {
	const {
		totalCenterGauge = 0,
		leftLeanPrice = 0,
		rightLeanPrice = 0,
		backLeanPrice = 0,
		frontLeanPrice = 0,
		totalCenterLegPrice = 0,
		totalLeftLegPrice = 0,
		totalRightLegPrice = 0,
		totalBackLegPrice = 0,
		totalFrontLegPrice = 0,
		totalRoofStylePrice = 0,
		totalSidewallCost = 0,
		windosandDoorPrice = 0,
		totalRoofPitchPrice = 0,
		frontRoofPitchPrice = 0,
		leftSideRoofPitchPrice = 0,
		rightSideRoofPitchPrice = 0,
		backRoofPitchPrice = 0,
		totalDiscount = 0,
		totalInsulationPrice = 0,
		panelUpgradePrice = 0,
		anchorsTotalPrice = 0,
		bracingTotalPrice = 0,
		autoBracingTotalPrice = 0,
		trussesTotalPrice = 0,
		texasCutTotal = 0,
		storagePanelsTotal = 0,
		foamClosureTotal = 0,
	} = prices;

	return (
		totalCenterGauge +
		leftLeanPrice +
		rightLeanPrice +
		backLeanPrice +
		frontLeanPrice +
		totalCenterLegPrice +
		totalLeftLegPrice +
		totalRightLegPrice +
		totalBackLegPrice +
		totalFrontLegPrice +
		totalRoofStylePrice +
		totalSidewallCost +
		windosandDoorPrice +
		totalRoofPitchPrice +
		frontRoofPitchPrice +
		leftSideRoofPitchPrice +
		rightSideRoofPitchPrice +
		backRoofPitchPrice +
		totalInsulationPrice +
		panelUpgradePrice +
		anchorsTotalPrice +
		bracingTotalPrice +
		autoBracingTotalPrice +
		trussesTotalPrice +
		texasCutTotal +
		storagePanelsTotal +
		foamClosureTotal -
		totalDiscount
	);
};
